import { useAuth } from '../../components/auth/AuthProvider'
import { useMyInboxCount } from './useInboxTasks'

// The user's pending workload: server-counted inbox tasks (assigned + eligible
// pools, uncapped). The inbox count is authoritative and shared by the sidebar
// badge, the Home card and the tasks-view counter, so all three agree.
export function useMyPendingTasksCount(): number {
  const { isLoaded: authLoaded } = useAuth()
  const { data: inboxCount = 0 } = useMyInboxCount(authLoaded)
  return inboxCount
}
